import styled from 'styled-components';
import { Body1 } from '../../../../shared/typography';
import { Media } from '../../../../styles/media';

const { tabletUp } = Media;

export const Container = styled.div`
  ${tabletUp`
    margin-top: 30px;
  `};
`;

export const GetApp = styled(Body1)`
  margin: 0 0 16px 0;
`;

export const BadgeContainer = styled.div`
  display: grid;
  grid-gap: 8px;
  grid-auto-flow: column;
  width: fit-content;
`;
